import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  arrayRemove,
  arrayUnion,
} from "firebase/firestore";
import { db } from "../config/Firebase";
import Header from "./Header";
import Footer from "./Footer";
import MetaTags from "./MetaTags";
import StructuredData from "./StructuredData";
import {
  FaHeart,
  FaLink,
  FaChevronLeft,
  FaChevronRight,
  FaShareAlt,
  FaTimes,
} from "react-icons/fa";
import validator from "validator";
import { motion, AnimatePresence } from "framer-motion";

// Import images
import singleVision from "../assets/images/single vision.jpg";
import Bifocal from "../assets/images/bifocal.jpg";
import FrameOnly from "../assets/images/single vision.jpg";
import hardcoat from "../assets/images/hardcoat-singlevision.png";
import nopower from "../assets/images/nopower.jpg";
import sv2 from "../assets/images/sv2.png";
import sv3 from "../assets/images/sv3.webp";
import sv4 from "../assets/images/sv4.webp";
import sv5 from "../assets/images/sv5.webp";
import sv6 from "../assets/images/sv6.webp";
import sv7 from "../assets/images/sv7.webp";
import sv8 from "../assets/images/sv8.webp";

//import share
// Replace ALL icon imports with this single combined import:

import {
  EmailShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  FacebookMessengerIcon,
  WhatsappIcon,
} from "react-share";

export default function ProductDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSharePopup, setShowSharePopup] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const phone = user.phone || "";
  const email = user.email || "";
  const username = user.username || "";
  const product = location?.state;
  const [liked, setLiked] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showLensPopup, setShowLensPopup] = useState(false);
  const [showNewLensPopup, setShowNewLensPopup] = useState(false);
  const [showSingleVisionPopup, setShowSingleVisionPopup] = useState(false);
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [leftLens, setLeftLens] = useState(0.0);
  const [rightLens, setRightLens] = useState(0.0);
  const [selectedLensOption, setSelectedLensOption] = useState(null);
  const [showFullDetails, setShowFullDetails] = useState(false);
  const [selectedLensDetails, setSelectedLensDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSunglassProduct, setIsSunglassProduct] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    // Load Facebook SDK if not already loaded
    if (!window.FB) {
      const script = document.createElement("script");
      script.src =
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    }
  }, []);
  const getShareUrl = () => {
    // Use actual URL in production
    if (
      process.env.NODE_ENV === "production" &&
      window.location.href.startsWith("http")
    ) {
      return window.location.href;
    }
    // Use your actual domain for better link previews
    return `https://www.arameyecare.com/product-details?id=${product?.ProductID}`;
  };

  const [showSocialOptions, setShowSocialOptions] = useState(false);

  const handleSocialShare = () => {
    setShowSocialOptions(true);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showSocialOptions &&
        !event.target.closest(".social-share-dropdown")
      ) {
        setShowSocialOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSocialOptions]);

  const handleFacebookMessenger = () => {
    const shareUrl = getShareUrl();
    const shareText = `Check out "${product?.Name}" (${product?.FrameColor}) - Only ₹${product?.Cost}!`;
    const fullText = `${shareText} ${shareUrl}`;

    // Facebook doesn't allow direct pre-filled messaging, so we'll copy text and guide user to Messenger
    navigator.clipboard
      .writeText(fullText)
      .then(() => {
        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );

        if (isMobile) {
          // On mobile, try to open Messenger app directly
          try {
            // Try to open Messenger app
            window.location.href = "fb-messenger://";

            // Show instructions immediately
            setTimeout(() => {
              alert(
                "✅ Product details copied!\n\n📱 Steps to share:\n1. Select any chat in Messenger\n2. Paste the copied text\n3. Send to share the product!"
              );
            }, 500);

            // Fallback to web if app doesn't open
            setTimeout(() => {
              if (document.hidden === false) {
                // If still on our page, app didn't open
                window.open(
                  "https://m.messenger.com/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }
            }, 2000);
          } catch (e) {
            window.open(
              "https://m.messenger.com/",
              "_blank",
              "noopener,noreferrer"
            );
            alert(
              "✅ Product details copied!\n\n📱 Steps to share:\n1. Select any chat in Messenger\n2. Paste the copied text\n3. Send to share the product!"
            );
          }
        } else {
          // On desktop, open Messenger web
          window.open(
            "https://www.messenger.com/",
            "_blank",
            "noopener,noreferrer"
          );
          alert(
            "✅ Product details copied to clipboard!\n\n💻 Steps to share:\n1. Choose any chat in Messenger\n2. Paste (Ctrl+V) the copied text\n3. Send to share the product!"
          );
        }
      })
      .catch(() => {
        // If clipboard fails, show manual copy instructions
        alert(
          `📋 Please copy this text and share in Messenger:\n\n${fullText}\n\n📱 Then go to Messenger and paste it in any chat!`
        );

        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        if (isMobile) {
          window.open(
            "https://m.messenger.com/",
            "_blank",
            "noopener,noreferrer"
          );
        } else {
          window.open(
            "https://www.messenger.com/",
            "_blank",
            "noopener,noreferrer"
          );
        }
      });

    setShowSocialOptions(false);
  };

  const handleInstagramDirect = () => {
    const shareUrl = getShareUrl();
    const shareText = `🔥 Check out this amazing eyewear!\n\n👓 ${product?.Name}\n🎨 Color: ${product?.FrameColor}\n💰 Price: ₹${product?.Cost}\n\n✨ View details: ${shareUrl}\n\n#AramEyeCare #Eyewear #Fashion`;

    // Instagram sharing strategy
    navigator.clipboard
      .writeText(shareText)
      .then(() => {
        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );

        if (isMobile) {
          // Try Instagram Stories sharing first (better for link previews)
          try {
            // Create a temporary link element for Instagram Stories
            const instagramStoriesUrl = `instagram://story-camera`;
            window.location.href = instagramStoriesUrl;

            // Show enhanced instructions
            setTimeout(() => {
              alert(
                "✅ Product details copied!\n\n📱 Instagram Sharing Options:\n\n🎬 STORIES (Recommended):\n1. Add photo/text to your story\n2. Paste the copied text\n3. Your followers can swipe up to view!\n\n💬 DIRECT MESSAGES:\n1. Go to DM icon\n2. Select any chat\n3. Paste the copied text\n4. Send to share!"
              );
            }, 500);

            // Fallback to DMs if Stories doesn't work
            setTimeout(() => {
              if (document.hidden === false) {
                window.open(
                  "https://www.instagram.com/direct/inbox/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }
            }, 3000);
          } catch (e) {
            // Direct fallback to Instagram DMs
            window.open(
              "https://www.instagram.com/direct/inbox/",
              "_blank",
              "noopener,noreferrer"
            );
            alert(
              "✅ Product details copied!\n\n📱 Steps to share:\n1. Go to Direct Messages\n2. Select any chat or start new chat\n3. Paste the copied text\n4. Send to share the product!"
            );
          }
        } else {
          // Desktop: Open Instagram web with better instructions
          window.open(
            "https://www.instagram.com/",
            "_blank",
            "noopener,noreferrer"
          );
          alert(
            "✅ Product details copied to clipboard!\n\n💻 Instagram Sharing Steps:\n\n📝 CREATE POST:\n1. Click '+' to create new post\n2. Upload product image or screenshot\n3. Paste copied text as caption\n4. Share to feed!\n\n💬 DIRECT MESSAGE:\n1. Click message icon (top right)\n2. Choose any chat\n3. Paste (Ctrl+V) the copied text\n4. Send to share!"
          );
        }
      })
      .catch(() => {
        // Enhanced fallback with better formatting
        const fallbackText = `🔥 Check out this amazing eyewear!\n\n👓 ${product?.Name}\n🎨 Color: ${product?.FrameColor}\n💰 Price: ₹${product?.Cost}\n\n✨ View details: ${shareUrl}\n\n#AramEyeCare #Eyewear #Fashion`;

        alert(
          `📋 Please copy this text and share on Instagram:\n\n${fallbackText}\n\n💡 Tip: This formatted text works great for Instagram posts and stories!`
        );

        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );

        if (isMobile) {
          window.open(
            "https://www.instagram.com/",
            "_blank",
            "noopener,noreferrer"
          );
        } else {
          window.open(
            "https://www.instagram.com/",
            "_blank",
            "noopener,noreferrer"
          );
        }
      });

    setShowSocialOptions(false);
  };

  const imageUrls = [
    product?.ImageUrl1,
    product?.ImageUrl2,
    product?.ImageUrl3,
    product?.ImageUrl4,
  ].filter(Boolean);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!phone || !email || !username) {
      console.warn("Incomplete user data in localStorage");
      setError("Please log in to view product details");
      navigate("/login");
      return;
    }

    const fetchWishlist = async () => {
      if (!phone || !product?.ProductID) return;
      try {
        const wishlistDocRef = doc(db, "Wishlist", phone);
        const wishlistDocSnap = await getDoc(wishlistDocRef);
        if (wishlistDocSnap.exists()) {
          const existingProductIDs = wishlistDocSnap.data().ProductID || [];
          setLiked(existingProductIDs.includes(product.ProductID));
        }
      } catch (err) {
        console.error("Error fetching wishlist:", err.message);
        setError("Failed to load wishlist. Please try again.");
      }
    };
    fetchWishlist();
  }, [phone, product, navigate, email, username]);

  useEffect(() => {
    const checkSunglassCollection = async () => {
      if (!product?.ProductID) return;
      try {
        const collectionNames = ["Kids-Sunglass", "Sunglassess"];
        const docRefs = collectionNames.map((name) =>
          doc(db, name, product.ProductID)
        );
        const docSnaps = await Promise.all(docRefs.map((ref) => getDoc(ref)));
        const isSunglass =
          docSnaps.some((snap) => snap.exists()) ||
          (product?.Collection &&
            ["kids-sunglass", "sunglasses", "sunglass"].includes(
              product.Collection.toLowerCase()
            ));
        setIsSunglassProduct(isSunglass);
      } catch (err) {
        console.error("Error checking sunglass collections:", err.message);
        setIsSunglassProduct(
          product?.Collection &&
            ["kids-sunglass", "sunglasses", "sunglass"].includes(
              product.Collection.toLowerCase()
            )
        );
      }
    };
    checkSunglassCollection();
  }, [product]);

  const validateInputs = () => {
    if (!product?.ProductID) {
      setError("Product ID is missing");
      return false;
    }
    if (!product?.Cost) {
      setError("Product cost information is missing");
      return false;
    }
    const cleanedCost = String(product.Cost).replace(/[^0-9.]/g, "");
    if (!/^\d+(\.\d{1,2})?$/.test(cleanedCost)) {
      setError("Invalid product cost format");
      return false;
    }
    if (!validator.isEmail(email)) {
      setError("Please provide a valid email address");
      return false;
    }
    if (!/^[0-9]{10}$/.test(phone)) {
      setError("Invalid phone number format (must be 10 digits)");
      return false;
    }
    if (!username) {
      setError("Customer name is missing");
      return false;
    }
    return true;
  };

  const handleAddToWishlist = async () => {
    if (!product?.ProductID) return;
    try {
      const wishlistDocRef = doc(db, "Wishlist", phone);
      const wishlistDocSnap = await getDoc(wishlistDocRef);
      const existingProductIDs = wishlistDocSnap.exists()
        ? wishlistDocSnap.data().ProductID || []
        : [];
      if (!existingProductIDs.includes(product.ProductID)) {
        await setDoc(
          wishlistDocRef,
          { ProductID: [...existingProductIDs, product.ProductID] },
          { merge: true }
        );
        setLiked(true);
        alert("Added to wishlist!");
      }
    } catch (err) {
      console.error("Wishlist error:", err.message);
      setError("Failed to add to wishlist. Please try again.");
    }
  };

  const handleRemoveFromWishlist = async () => {
    if (!product?.ProductID) return;
    try {
      const wishlistDocRef = doc(db, "Wishlist", phone);
      await updateDoc(wishlistDocRef, {
        ProductID: arrayRemove(product.ProductID),
      });
      setLiked(false);
      alert("Removed from wishlist!");
    } catch (err) {
      console.error("Wishlist removal error:", err.message);
      setError("Failed to remove from wishlist. Please try again.");
    }
  };

  const handleLikeClick = () => {
    if (!phone) {
      setError("Please log in to manage wishlist");
      return;
    }
    liked ? handleRemoveFromWishlist() : handleAddToWishlist();
  };

  const handleBuyNow = async (option) => {
    if (!validateInputs()) return;
    setSelectedLensOption(option);
    setShowNewLensPopup(false);
    if (option.id === 1) {
      setShowSingleVisionPopup(true);
    } else {
      try {
        const cartDocRef = doc(db, "Cart", phone);
        await setDoc(
          cartDocRef,
          {
            products: arrayUnion({
              ProductID: product.ProductID,
              name: option.name, // Store lens type (e.g., "Bifocal/Progressive")
              lensOptions: null, // No specific lens option for non-single vision
              LeftLensPower: 0,
              RightLensPower: 0,
              LeftCylindrical: 0,
              LeftAxis: 0,
              RightCylindrical: 0,
              RightAxis: 0,
              timestamp: new Date(),
            }),
          },
          { merge: true }
        );
      } catch (err) {
        console.error("Error adding lens type to cart:", err.message);
        setError("Failed to add lens type to cart. Please try again.");
      }
      navigate("/OrderDetails", {
        state: {
          product,
          lensOption: option,
          leftLens: 0,
          rightLens: 0,
          totalCost: Number(product.Cost) + (option.basePrice || 0),
        },
      });
    }
  };

  const handleSingleVisionConfirm = async (lensDetails) => {
    setLeftLens(lensDetails.leftSpherical || 0);
    setRightLens(lensDetails.rightSpherical || 0);
    try {
      const cartDocRef = doc(db, "Cart", phone);
      await setDoc(
        cartDocRef,
        {
          products: arrayUnion({
            ProductID: product.ProductID,
            name: selectedLensOption.name, // Store "Single Vision"
            lensOptions: lensDetails.name, // Store specific lens option (e.g., "Hardcoat - Standard")
            LeftLensPower: lensDetails.leftSpherical || 0,
            RightLensPower: lensDetails.rightSpherical || 0,
            LeftCylindrical: lensDetails.leftCylindrical || 0,
            LeftAxis: lensDetails.leftAxis || 0,
            RightCylindrical: lensDetails.rightCylindrical || 0,
            RightAxis: lensDetails.rightAxis || 0,
            timestamp: new Date(),
          }),
        },
        { merge: true }
      );
    } catch (err) {
      console.error("Error adding single vision lens to cart:", err.message);
      setError("Failed to add single vision lens to cart. Please try again.");
    }
    navigate("/OrderDetails", {
      state: {
        product,
        lensOption: { ...selectedLensOption, details: lensDetails },
        leftSpherical: lensDetails.leftSpherical || 0,
        leftCylindrical: lensDetails.leftCylindrical || 0,
        leftAxis: lensDetails.leftAxis || 0,
        rightSpherical: lensDetails.rightSpherical || 0,
        rightCylindrical: lensDetails.rightCylindrical || 0,
        rightAxis: lensDetails.rightAxis || 0,
        totalCost: Number(product.Cost) + Number(lensDetails.basePrice),
      },
    });
  };

  const handleShowFullDetails = (lens) => {
    setSelectedLensDetails(lens.fullDetails);
    setShowFullDetails(true);
  };

  if (error) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center justify-center h-screen bg-gray-100"
      >
        <p className="text-red-500 text-xl md:text-2xl font-semibold mb-4">
          {error}
        </p>
        <button
          onClick={() => navigate(-1)}
          className="px-4 md:px-6 py-2 md:py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors duration-300"
        >
          Go Back
        </button>
      </motion.div>
    );
  }

  if (!product?.ProductID) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center justify-center h-screen bg-gray-100"
      >
        <p className="text-red-500 text-xl md:text-2xl font-semibold mb-4">
          Product data missing!
        </p>
        <button
          onClick={() => navigate(-1)}
          className="px-4 md:px-6 py-2 md:py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors duration-300"
        >
          Go Back
        </button>
      </motion.div>
    );
  }

  return (
    <>
      <MetaTags product={product} />
      <StructuredData product={product} />
      <Header />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto px-4 py-8 md:py-12 bg-gradient-to-b from-gray-50 to-white min-h-screen"
      >
        <h1 className="text-2xl md:text-4xl font-extrabold text-center mb-6 md:mb-10 text-gray-900 tracking-tight">
          {product.Name || "Product Name"}
        </h1>

        <div className="flex flex-col lg:flex-row gap-6 md:gap-12">
          {/* Image Gallery */}
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2"
          >
            <div className="space-y-4 md:space-y-6">
              <div className="relative bg-white rounded-xl md:rounded-2xl shadow-lg md:shadow-xl overflow-hidden">
                {imageUrls.length > 0 ? (
                  <AnimatePresence mode="wait">
                    <motion.img
                      key={currentImageIndex}
                      src={imageUrls[currentImageIndex]}
                      alt={product.Name || "Product Image"}
                      initial={{ opacity: 0, scale: 1.1 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      className="w-full h-auto object-contain max-h-[400px] md:max-h-[600px]"
                      onError={(e) => {
                        console.error(
                          "Image failed to load:",
                          imageUrls[currentImageIndex]
                        );
                        e.target.src =
                          "https://via.placeholder.com/600?text=Image+Not+Found";
                      }}
                    />
                  </AnimatePresence>
                ) : (
                  <div className="flex items-center justify-center h-[300px] md:h-[600px] text-gray-500 bg-gray-100">
                    No images available
                  </div>
                )}
                {imageUrls.length > 1 && (
                  <>
                    <button
                      className="absolute top-1/2 left-2 md:left-4 transform -translate-y-1/2 bg-white/80 text-gray-800 p-2 md:p-3 rounded-full hover:bg-white shadow-sm md:shadow-md transition-all duration-300"
                      onClick={() =>
                        setCurrentImageIndex(
                          (prev) =>
                            (prev - 1 + imageUrls.length) % imageUrls.length
                        )
                      }
                    >
                      <FaChevronLeft className="text-lg md:text-xl" />
                    </button>
                    <button
                      className="absolute top-1/2 right-2 md:right-4 transform -translate-y-1/2 bg-white/80 text-gray-800 p-2 md:p-3 rounded-full hover:bg-white shadow-sm md:shadow-md transition-all duration-300"
                      onClick={() =>
                        setCurrentImageIndex(
                          (prev) => (prev + 1) % imageUrls.length
                        )
                      }
                    >
                      <FaChevronRight className="text-lg md:text-xl" />
                    </button>
                  </>
                )}
              </div>
              <div className="grid grid-cols-3 gap-2 md:grid-cols-4 md:gap-3">
                {imageUrls.map((url, index) => (
                  <motion.img
                    key={index}
                    src={url}
                    alt={`Thumbnail ${index + 1}`}
                    className={`w-full h-16 md:h-24 object-cover rounded-md md:rounded-lg cursor-pointer transition-all duration-300 ${
                      currentImageIndex === index
                        ? "border-2 border-black shadow-md"
                        : "opacity-80 hover:opacity-100 hover:shadow-md"
                    }`}
                    onClick={() => setCurrentImageIndex(index)}
                    whileHover={{ scale: 1.05 }}
                    onError={(e) => {
                      console.error("Thumbnail failed to load:", url);
                      e.target.src =
                        "https://via.placeholder.com/100?text=Thumbnail+Not+Found";
                    }}
                  />
                ))}
              </div>
            </div>
          </motion.div>

          {/* Product Details */}
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:w-1/2 space-y-4 md:space-y-6"
          >
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
              <span
                className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium ${
                  product.Availability === "In Stock"
                    ? "bg-green-200 text-green-800"
                    : "bg-red-200 text-red-800"
                }`}
              >
                {product.Availability || "In Stock"}
              </span>
              <div className="flex items-center gap-2"></div>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleLikeClick}
                className="flex items-center gap-1 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-300 shadow-sm"
              >
                <FaHeart
                  className={`text-xl md:text-2xl ${
                    liked ? "text-red-500" : "text-gray-400"
                  } transition-colors duration-300`}
                />
                <span className="text-xs md:text-sm font-medium">
                  {liked ? "Wishlisted" : "Wishlist"}
                </span>
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  try {
                    setShowSharePopup(true);
                  } catch (e) {
                    handleSocialShare();
                  }
                }}
                className="flex items-center gap-1 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-300 shadow-sm"
              >
                <FaShareAlt className="text-xl md:text-2xl text-blue-500" />
                <span className="text-xs md:text-sm font-medium">Share</span>
              </motion.button>
            </div>

            <div className="bg-white p-4 md:p-8 rounded-xl md:rounded-2xl shadow-lg md:shadow-xl">
              <div className="grid grid-cols-2 gap-3 md:gap-4 text-sm md:text-base">
                <span className="font-medium text-gray-700">Price:</span>
                <span className="text-lg md:text-2xl font-bold text-gray-900">
                  ₹{product.Cost || "N/A"}
                </span>
                <span className="font-medium text-gray-700">Color:</span>
                <span className="text-gray-900">
                  {product.FrameColor || "N/A"}
                </span>
                <span className="font-medium text-gray-700">Material:</span>
                <span className="text-gray-900">
                  {product.Material || "N/A"}
                </span>
                <span className="font-medium text-gray-700">Shape:</span>
                <span className="text-gray-900">{product.Shape || "N/A"}</span>
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowDescriptionPopup(true)}
                className="mt-3 md:mt-4 text-sm md:text-base text-blue-600 hover:text-blue-800 hover:underline font-medium"
              >
                View Full Description
              </motion.button>
            </div>

            <div className="flex flex-col gap-3 md:gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  if (!phone) {
                    setError("Please log in to buy now");
                    return;
                  }
                  if (isSunglassProduct) {
                    if (!validateInputs()) return;
                    const defaultLensOption = {
                      id: 4,
                      name: "Frame Only",
                      description: "Frame without lenses",
                      basePrice: 0,
                    };
                    navigate("/OrderDetails", {
                      state: {
                        product,
                        lensOption: defaultLensOption,
                        leftLens: 0,
                        rightLens: 0,
                        totalCost: Number(product.Cost) || 0,
                      },
                    });
                  } else {
                    setShowNewLensPopup(true);
                  }
                }}
                className="w-full py-3 md:py-4 bg-black text-white rounded-lg shadow-lg hover:bg-gray-800 disabled:bg-gray-400 transition-all duration-300 text-sm md:text-base font-semibold"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Buy Now"}
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(-1)}
                className="w-full py-3 md:py-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors duration-300 text-sm md:text-base font-medium"
              >
                Continue Shopping
              </motion.button>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Description Popup */}
      <AnimatePresence>
        {showDescriptionPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-md w-full shadow-2xl"
            >
              <div className="flex justify-between items-center mb-4 md:mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                  Product Description
                </h2>
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setShowDescriptionPopup(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimes className="text-lg md:text-xl" />
                </motion.button>
              </div>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                {product.Description || "No description available."}
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowDescriptionPopup(false)}
                className="mt-4 md:mt-6 w-full py-2 md:py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors duration-300 text-sm md:text-base"
              >
                Close
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Lens Power Popup */}
      <AnimatePresence>
        {showLensPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-lg w-full shadow-2xl"
            >
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">
                Enter Lens Power
              </h2>
              <div className="space-y-4 md:space-y-6">
                {/* Left Eye */}
                <div className="space-y-2">
                  <label className="block text-sm md:text-base font-medium text-gray-700">
                    Left Eye
                  </label>
                  <div className="flex items-center gap-2">
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() =>
                        setLeftLens((prev) => Math.max(-10, prev - 0.25))
                      }
                      className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-300"
                    >
                      <span className="text-lg">-</span>
                    </motion.button>
                    <input
                      type="number"
                      step="0.25"
                      value={leftLens}
                      onChange={(e) =>
                        setLeftLens(
                          Math.min(
                            10,
                            Math.max(-10, parseFloat(e.target.value) || 0)
                          )
                        )
                      }
                      className="flex-1 text-center border-2 border-gray-300 rounded-lg py-2 text-sm md:text-base font-medium focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition"
                    />
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() =>
                        setLeftLens((prev) => Math.min(10, prev + 0.25))
                      }
                      className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-300"
                    >
                      <span className="text-lg">+</span>
                    </motion.button>
                  </div>
                </div>
                {/* Right Eye */}
                <div className="space-y-2">
                  <label className="block text-sm md:text-base font-medium text-gray-700">
                    Right Eye
                  </label>
                  <div className="flex items-center gap-2">
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() =>
                        setRightLens((prev) => Math.max(-10, prev - 0.25))
                      }
                      className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-300"
                    >
                      <span className="text-lg">-</span>
                    </motion.button>
                    <input
                      type="number"
                      step="0.25"
                      value={rightLens}
                      onChange={(e) =>
                        setRightLens(
                          Math.min(
                            10,
                            Math.max(-10, parseFloat(e.target.value) || 0)
                          )
                        )
                      }
                      className="flex-1 text-center border-2 border-gray-300 rounded-lg py-2 text-sm md:text-base font-medium focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition"
                    />
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() =>
                        setRightLens((prev) => Math.min(10, prev + 0.25))
                      }
                      className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-300"
                    >
                      <span className="text-lg">+</span>
                    </motion.button>
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row justify-end gap-2 mt-6 md:mt-8">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setShowLensPopup(false)}
                  className="px-4 py-2 md:px-6 md:py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors duration-300 text-sm md:text-base"
                >
                  Cancel
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={async () => {
                    if (isLoading) return;
                    setIsLoading(true);
                    try {
                      const cartDocRef = doc(db, "Cart", phone);
                      await updateDoc(cartDocRef, {
                        products: arrayUnion({
                          ProductID: product.ProductID,
                          LeftLensPower: leftLens,
                          RightLensPower: rightLens,
                          timestamp: new Date(),
                        }),
                      });
                      setShowLensPopup(false);
                      alert("Added to cart successfully!");
                    } catch (error) {
                      console.error("Cart error:", error);
                      setError("Error adding to cart: " + error.message);
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                  className="px-4 py-2 md:px-6 md:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors duration-300 text-sm md:text-base"
                  disabled={isLoading}
                >
                  {isLoading ? "Processing..." : "Confirm"}
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* New Lens Popup */}
      {showNewLensPopup && (
        <ShowNewLensPopup
          onClose={() => setShowNewLensPopup(false)}
          onConfirm={handleBuyNow}
        />
      )}

      {/* Single Vision Popup */}
      {showSingleVisionPopup && (
        <SingleVisionPopup
          onClose={() => setShowSingleVisionPopup(false)}
          onConfirm={handleSingleVisionConfirm}
          onShowDetails={handleShowFullDetails}
          isLoading={isLoading}
          setShowSingleVisionPopup={setShowSingleVisionPopup}
        />
      )}

      {/* Full Details Popup */}
      <AnimatePresence>
        {showFullDetails && selectedLensDetails && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-2xl w-full shadow-2xl"
            >
              <div className="flex justify-between items-start mb-4 md:mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                  {selectedLensDetails.name}
                </h2>
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setShowFullDetails(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimes className="text-lg md:text-xl" />
                </motion.button>
              </div>
              <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                <img
                  src={selectedLensDetails.image}
                  alt={selectedLensDetails.name}
                  className="w-full h-48 md:h-64 object-contain rounded-lg"
                />
                <div className="space-y-3 md:space-y-4">
                  <h3 className="text-lg md:text-xl font-semibold text-gray-900">
                    Features
                  </h3>
                  <ul className="list-disc pl-5 md:pl-6 space-y-1 md:space-y-2 text-sm md:text-base text-gray-700">
                    {selectedLensDetails.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <p className="text-base md:text-lg font-semibold text-gray-900">
                    Base Price: ₹{selectedLensDetails.basePrice}
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* Share Popup */}
      {/* Share Popup */}
      <AnimatePresence>
        {showSharePopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-white rounded-xl p-6 max-w-md w-full shadow-xl"
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-gray-900">
                  Share this product
                </h3>
                <button
                  onClick={() => setShowSharePopup(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimes className="text-xl" />
                </button>
              </div>
              <div className="mt-4">
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(getShareUrl());
                    alert("Link copied to clipboard!");
                  }}
                  className="w-full py-2 px-4 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center justify-center gap-2"
                >
                  <FaLink className="text-blue-500" />
                  <span>Copy Link</span>
                </button>
              </div>
              <div className="flex flex-wrap gap-3 justify-center mt-6">
                {/* Social Share Button */}
                <div className="relative social-share-dropdown">
                  <button
                    onClick={handleSocialShare}
                    className="p-2 rounded-full hover:bg-gray-100 transition"
                    title="Share via Facebook or Instagram"
                  >
                    <FacebookMessengerIcon size={40} round />
                  </button>

                  {/* Social Options Dropdown */}
                  {showSocialOptions && (
                    <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white border border-gray-200 rounded-lg shadow-lg p-2 min-w-48 z-50">
                      <div className="text-sm font-medium text-gray-700 mb-2 text-center">
                        Share via:
                      </div>
                      <button
                        onClick={handleFacebookMessenger}
                        className="w-full flex items-center gap-2 p-2 hover:bg-blue-50 rounded-md transition"
                      >
                        <FacebookMessengerIcon size={24} round />
                        <span>Facebook Messenger</span>
                      </button>
                      <button
                        onClick={handleInstagramDirect}
                        className="w-full flex items-center gap-2 p-2 hover:bg-pink-50 rounded-md transition"
                      >
                        <div className="w-6 h-6 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                          <span className="text-white text-xs font-bold">
                            IG
                          </span>
                        </div>
                        <span>Instagram Share</span>
                      </button>
                      <button
                        onClick={() => setShowSocialOptions(false)}
                        className="w-full text-center text-gray-500 text-sm p-1 hover:text-gray-700 transition"
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>

                {/* Other share buttons... */}
                <WhatsappShareButton
                  url={window.location.href}
                  title={`Check out ${product.Name} on Eyeglass Store!`}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <WhatsappIcon size={40} round />
                </WhatsappShareButton>

                {/* Rest of your share buttons */}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <Footer />
    </>
  );
}

const ShowNewLensPopup = ({ onClose, onConfirm }) => {
  const lensOptions = [
    {
      id: 1,
      name: "Single Vision",
      image: singleVision,
      description: "Corrects vision at one distance",
    },
    {
      id: 2,
      name: "Frame Only",
      image: FrameOnly,
      description: "Frame without lenses",
      basePrice: 0,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-md w-full shadow-2xl"
      >
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">
          Select Lens Type
        </h2>
        <div className="grid grid-cols-1 gap-3 md:gap-4">
          {lensOptions.map((option) => (
            <motion.button
              key={option.id}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onConfirm(option)}
              className="p-3 md:p-4 border rounded-lg hover:shadow-md transition-all duration-300"
            >
              <img
                src={option.image}
                alt={option.name}
                className="w-full h-24 md:h-32 object-contain mb-2"
              />
              <div className="text-left">
                <h3 className="text-sm md:text-base font-semibold text-gray-900">
                  {option.name}
                </h3>
                <p className="text-xs md:text-sm text-gray-600">
                  {option.description}
                </p>
              </div>
            </motion.button>
          ))}
        </div>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onClose}
          className="mt-4 md:mt-6 w-full py-2 md:py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors duration-300 text-sm md:text-base"
        >
          Close
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

const SingleVisionPopup = ({
  onClose,
  onConfirm,
  onShowDetails,
  isLoading,
  setShowSingleVisionPopup,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [leftSpherical, setLeftSpherical] = useState(0);
  const [leftCylindrical, setLeftCylindrical] = useState(0);
  const [leftAxis, setLeftAxis] = useState(0);
  const [rightSpherical, setRightSpherical] = useState(0);
  const [rightCylindrical, setRightCylindrical] = useState(0);
  const [rightAxis, setRightAxis] = useState(0);
  const [showLensPowerPopup, setShowLensPowerPopup] = useState(false);

  const lensOptions = [
    {
      id: "Hardcoat - Standard",
      name: "Hardcoat - Standard",
      image: hardcoat,
      features: [
        "Lens material: Cr (Fibre)",
        "Warranty: 1 year coating warranty",
        "Price: ₹700 + frame",
      ],
      fullDetails: {
        id: "Hardcoat - Standard",
        name: "Hardcoat - Standard",
        image: hardcoat,
        features: [
          "Lens material: Cr (Fibre)",
          "Index: 1.56",
          "Design: Aspheric",
          "Features: Scratch resistance coating",
          "Warranty: 1 year coating warranty",
          "Price: ₹700 + frame",
          "Power range: Lens Power ranges above +/- 10 D.sph, +/- 3 D.cyl would be upgraded for Rx lens and ₹300 charged per pair",
        ],
        basePrice: 700,
      },
      basePrice: 700,
    },
    {
      id: "Anti Glare Control - Standard",
      name: "Anti Glare Control - Standard",
      image: sv2,
      features: [
        "Lens material: Cr (Fibre)",
        "Warranty: 1 year coating warranty",
        "Price: ₹1200 + frame",
      ],
      fullDetails: {
        id: "Anti Glare Control - Standard",
        name: "Anti Glare Control - Standard",
        image: sv2,
        features: [
          "Lens material: Cr (Fibre)",
          "Index: 1.56",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating",
          "Warranty: 1 year coating warranty",
          "Price: ₹1200 + frame",
          "Power range: Lens Power ranges above +/- 10 D.sph, +/- 3 D.cyl would be upgraded for Rx lens and ₹400 charged per pair",
        ],
        basePrice: 1200,
      },
      basePrice: 1200,
    },
    {
      id: "Blue Cut Lenses - Standard (Green)",
      name: "Blue Cut Lenses - Standard (Green)",
      image: sv3,
      features: [
        "Lens material: Cr (Fibre)",
        "Warranty: 1 year coating warranty",
        "Price: ₹1600 + frame",
      ],
      fullDetails: {
        id: "Blue Cut Lenses - Standard (Green)",
        name: "Blue Cut Lenses - Standard (Green)",
        image: sv3,
        features: [
          "Lens material: Cr (Fibre)",
          "Index: 1.56",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating, Filters out blue radiation",
          "Colour of coating: Green",
          "Warranty: 1 year coating warranty",
          "Price: ₹1600 + frame",
          "Power range: Lens Power ranges above +/- 10 D.sph, +/- 3 D.cyl would be upgraded for Rx lens and ₹400 charged per pair",
        ],
        basePrice: 1600,
      },
      basePrice: 1600,
    },
    {
      id: "Blue Cut Lenses - Standard (Blue)",
      name: "Blue Cut Lenses - Standard (Blue)",
      image: sv4,
      features: [
        "Lens material: Cr (Fibre)",
        "Warranty: 1 year coating warranty",
        "Price: ₹2000 + frame",
      ],
      fullDetails: {
        id: "Blue Cut Lenses - Standard (Blue)",
        name: "Blue Cut Lenses - Standard (Blue)",
        image: sv4,
        features: [
          "Lens material: Cr (Fibre)",
          "Index: 1.56",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating, Filters out blue radiation",
          "Colour of coating: Blue",
          "Warranty: 1 year coating warranty",
          "Price: ₹2000 + frame",
          "Power range: Lens Power ranges above +/- 8 D.sph, +/- 3 D.cyl would be upgraded for Rx lens and ₹500 charged per pair",
        ],
        basePrice: 2000,
      },
      basePrice: 2000,
    },
    {
      id: "Blue Cut Lenses - Premium",
      name: "Blue Cut Lenses - Premium",
      image: sv5,
      features: [
        "Lens material: Cr (Fibre)",
        "Warranty: 1 year coating warranty",
        "Price: ₹2500 + frame",
      ],
      fullDetails: {
        id: "Blue Cut Lenses - Premium",
        name: "Blue Cut Lenses - Premium",
        image: sv5,
        features: [
          "Lens material: Cr (Fibre)",
          "Index: 1.56",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating, Filters out blue radiation, UV-400 coating, Smudge, water and dust repellent",
          "Colour of coating: Blue-violet (Dual coating)",
          "Warranty: 1 year coating warranty",
          "Price: ₹2500 + frame",
          "Power range: Available Power ranges upto +/- 8 D.sph and +/- 2 D.sph",
        ],
        basePrice: 2500,
      },
      basePrice: 2500,
    },
    {
      id: "Anti Glare Control - Standard (Polycarbonate)",
      name: "Anti Glare Control - Standard (Polycarbonate)",
      image: sv6,
      features: [
        "Lens material: Polycarbonate",
        "Warranty: 1 year coating warranty, 1 year breakage warranty",
        "Price: ₹2300 + frame",
      ],
      fullDetails: {
        id: "Anti Glare Control - Standard (Polycarbonate)",
        name: "Anti Glare Control - Standard (Polycarbonate)",
        image: sv6,
        features: [
          "Lens material: Polycarbonate",
          "Index: 1.59",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating",
          "Warranty: 1 year coating warranty, 1 year breakage warranty",
          "Price: ₹2300 + frame",
          "Power range: Lens Power ranges above +/- 6 D.sph, +/- 2 D.cyl would be upgraded for Rx lens and ₹600 charged per pair",
        ],
        basePrice: 2300,
      },
      basePrice: 2300,
    },
    {
      id: "Blue Cut Lenses - Premium (Polycarbonate)",
      name: "Blue Cut Lenses - Premium (Polycarbonate)",
      image: sv7,
      features: [
        "Lens material: Polycarbonate",
        "Warranty: 1 year coating warranty, 1 year breakage warranty",
        "Price: ₹3500 + frame",
      ],
      fullDetails: {
        id: "Blue Cut Lenses - Premium (Polycarbonate)",
        name: "Blue Cut Lenses - Premium (Polycarbonate)",
        image: sv7,
        features: [
          "Lens material: Polycarbonate",
          "Index: 1.59",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating, Filters out blue radiation, UV 400 coating, Smudge, Dust and water repellent coating",
          "Colour of coating: Blue (Dual coat)",
          "Warranty: 1 year coating warranty, 1 year breakage warranty",
          "Price: ₹3500 + frame",
          "Power range: Lens Power ranges above +/- 6 D.sph, +/- 2 D.cyl would be upgraded for Rx lens and ₹700 charged per pair",
        ],
        basePrice: 3500,
      },
      basePrice: 3500,
    },
    {
      id: "Anti Glare Control - Standard (MR8)",
      name: "Anti Glare Control - Standard (MR8)",
      image: sv8,
      features: [
        "Lens material: MR8 – Misui Resin 8th",
        "Warranty: 1 year coating warranty, 1 year breakage warranty",
        "Price: ₹2300 + frame",
      ],
      fullDetails: {
        id: "Anti Glare Control - Standard (MR8)",
        name: "Anti Glare Control - Standard (MR8)",
        image: sv8,
        features: [
          "Lens material: MR8 – Misui Resin 8th",
          "Index: 1.60",
          "Design: Aspheric",
          "Features: Hardcoat, Scratch resistance coating, Anti-Glare control coating",
          "Warranty: 1 year coating warranty, 1 year breakage warranty",
          "Price: ₹2300 + frame",
          "Power range: Lens Power ranges above +/- 6 D.sph, +/- 2 D.cyl would be upgraded for Rx lens and ₹600 charged per pair",
        ],
        basePrice: 2300,
      },
      basePrice: 2300,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
      >
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">
          Single Vision Options
        </h2>
        <div className="space-y-3 md:space-y-4">
          {lensOptions.map((option) => {
            const isSelected = selectedOption?.id === option.id;
            return (
              <motion.div
                key={option.id}
                whileHover={{ scale: 1.02 }}
                className={`p-3 md:p-4 rounded-lg border transition-all duration-300 cursor-pointer ${
                  isSelected
                    ? "bg-gradient-to-br from-gray-50 to-gray-100 border-black shadow-md"
                    : "bg-white border-gray-200 hover:border-gray-400 hover:shadow-md"
                }`}
                onClick={() => setSelectedOption(option)}
              >
                {isSelected && (
                  <span className="absolute top-2 md:top-4 right-2 md:right-4 bg-black text-white text-xs font-bold px-2 py-1 rounded-full shadow">
                    Selected
                  </span>
                )}
                <div className="flex items-start gap-3 md:gap-4">
                  <img
                    src={option.image}
                    alt={option.name}
                    className="w-16 h-16 md:w-24 md:h-24 object-contain rounded-md border border-gray-200 shadow-sm"
                  />
                  <div className="flex-1">
                    <h3 className="text-sm md:text-base font-semibold text-gray-900">
                      {option.name}
                    </h3>
                    <ul className="list-disc pl-4 text-gray-700 text-xs md:text-sm mb-2 md:mb-4 space-y-1">
                      {option.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                    <div className="flex justify-between items-center mt-2">
                      <p className="font-bold text-base md:text-lg text-gray-900">
                        ₹{option.basePrice}
                      </p>
                      <div className="flex gap-2 md:gap-3">
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            onShowDetails(option);
                          }}
                          className="text-xs md:text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline"
                        >
                          Details
                        </motion.button>
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedOption(option);
                          }}
                          className={`px-3 md:px-5 py-1 md:py-2 rounded-lg font-semibold transition-all duration-200 text-xs md:text-sm ${
                            isSelected
                              ? "bg-black text-white shadow-md hover:bg-gray-800"
                              : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                          }`}
                        >
                          {isSelected ? "Selected" : "Select"}
                        </motion.button>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="flex flex-col md:flex-row justify-end gap-2 mt-6 md:mt-8 pt-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClose}
            className="px-4 md:px-6 py-2 md:py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition text-sm md:text-base"
          >
            Cancel
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              if (selectedOption) setShowLensPowerPopup(true);
            }}
            className={`px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold transition text-sm md:text-base ${
              selectedOption
                ? "bg-black text-white hover:bg-gray-800 shadow"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
            disabled={!selectedOption || isLoading}
          >
            Confirm Selection
          </motion.button>
        </div>

        <AnimatePresence>
          {showLensPowerPopup && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50"
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 max-w-[95%] md:max-w-2xl w-full shadow-2xl"
              >
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">
                  Enter Lens Prescription
                </h2>
                <div className="space-y-4 md:space-y-6">
                  {/* Left Eye */}
                  <div>
                    <label className="block mb-2 font-semibold text-gray-800 text-sm md:text-base">
                      Left Eye
                    </label>
                    <div className="grid grid-cols-3 gap-3 md:gap-4">
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Spherical
                        </label>
                        <div className="flex items-center gap-2">
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setLeftSpherical((prev) =>
                                Math.max(-10, prev - 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            −
                          </motion.button>
                          <input
                            type="number"
                            step="0.25"
                            value={leftSpherical}
                            onChange={(e) =>
                              setLeftSpherical(
                                Math.min(
                                  10,
                                  Math.max(-10, parseFloat(e.target.value) || 0)
                                )
                              )
                            }
                            className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                          />
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setLeftSpherical((prev) =>
                                Math.min(10, prev + 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            +
                          </motion.button>
                        </div>
                      </div>
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Cylindrical
                        </label>
                        <div className="flex items-center gap-2">
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setLeftCylindrical((prev) =>
                                Math.max(-6, prev - 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            −
                          </motion.button>
                          <input
                            type="number"
                            step="0.25"
                            value={leftCylindrical}
                            onChange={(e) => {
                              const value = Math.min(
                                6,
                                Math.max(-6, parseFloat(e.target.value) || 0)
                              );
                              setLeftCylindrical(value);
                              if (value === 0) setLeftAxis(0);
                            }}
                            className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                          />
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setLeftCylindrical((prev) =>
                                Math.min(6, prev + 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            +
                          </motion.button>
                        </div>
                      </div>
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Axis
                        </label>
                        <input
                          type="number"
                          step="1"
                          min="0"
                          max="180"
                          value={leftCylindrical === 0 ? 0 : leftAxis}
                          onChange={(e) =>
                            leftCylindrical !== 0 &&
                            setLeftAxis(
                              Math.min(
                                180,
                                Math.max(0, parseInt(e.target.value) || 0)
                              )
                            )
                          }
                          disabled={leftCylindrical === 0}
                          className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none disabled:bg-gray-100"
                        />
                      </div>
                    </div>
                  </div>
                  {/* Right Eye */}
                  <div>
                    <label className="block mb-2 font-semibold text-gray-800 text-sm md:text-base">
                      Right Eye
                    </label>
                    <div className="grid grid-cols-3 gap-3 md:gap-4">
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Spherical
                        </label>
                        <div className="flex items-center gap-2">
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setRightSpherical((prev) =>
                                Math.max(-10, prev - 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            −
                          </motion.button>
                          <input
                            type="number"
                            step="0.25"
                            value={rightSpherical}
                            onChange={(e) =>
                              setRightSpherical(
                                Math.min(
                                  10,
                                  Math.max(-10, parseFloat(e.target.value) || 0)
                                )
                              )
                            }
                            className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                          />
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setRightSpherical((prev) =>
                                Math.min(10, prev + 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            +
                          </motion.button>
                        </div>
                      </div>
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Cylindrical
                        </label>
                        <div className="flex items-center gap-2">
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setRightCylindrical((prev) =>
                                Math.max(-6, prev - 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            −
                          </motion.button>
                          <input
                            type="number"
                            step="0.25"
                            value={rightCylindrical}
                            onChange={(e) => {
                              const value = Math.min(
                                6,
                                Math.max(-6, parseFloat(e.target.value) || 0)
                              );
                              setRightCylindrical(value);
                              if (value === 0) setRightAxis(0);
                            }}
                            className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                          />
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() =>
                              setRightCylindrical((prev) =>
                                Math.min(6, prev + 0.25)
                              )
                            }
                            className="px-2 md:px-3 py-1 border rounded-lg bg-gray-50 hover:bg-gray-100 text-base md:text-lg font-bold"
                          >
                            +
                          </motion.button>
                        </div>
                      </div>
                      <div>
                        <label className="block mb-1 text-xs md:text-sm font-medium text-gray-700">
                          Axis
                        </label>
                        <input
                          type="number"
                          step="1"
                          min="0"
                          max="180"
                          value={rightCylindrical === 0 ? 0 : rightAxis}
                          onChange={(e) =>
                            rightCylindrical !== 0 &&
                            setRightAxis(
                              Math.min(
                                180,
                                Math.max(0, parseInt(e.target.value) || 0)
                              )
                            )
                          }
                          disabled={rightCylindrical === 0}
                          className="w-full text-center border-2 border-gray-300 rounded-lg py-1 md:py-2 text-xs md:text-sm font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none disabled:bg-gray-100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row justify-end gap-2 mt-6 md:mt-8">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowLensPowerPopup(false)}
                    className="px-4 md:px-6 py-2 md:py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition text-sm md:text-base"
                  >
                    Cancel
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => {
                      if (selectedOption) {
                        onConfirm({
                          ...selectedOption,
                          leftSpherical,
                          leftCylindrical,
                          leftAxis,
                          rightSpherical,
                          rightCylindrical,
                          rightAxis,
                          basePrice: selectedOption.basePrice,
                        });
                        setShowLensPowerPopup(false);
                        setShowSingleVisionPopup(false);
                      }
                    }}
                    className="px-4 md:px-6 py-2 md:py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-300 text-sm md:text-base"
                    disabled={isLoading}
                  >
                    Confirm
                  </motion.button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </motion.div>
  );
};
